module.exports = __webpack_public_path__ + "img/vip-grand-lisboa-hotel-spa.009fff3e.jpg";